/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	OrganisationAnalyticsRowsQueryParams,
	OrganisationAnalyticsRowsResponse,
} from '../types/OrganisationAnalyticsRows'

/**
 * GET /analytics/overview/rows
 * @see backend/nexus/modules/Analytics/Http/Controllers/OrganisationAnalyticsController.php OrganisationAnalyticsController::rows
 */
export async function organisationAnalyticsRows(
	params?: OrganisationAnalyticsRowsQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganisationAnalyticsRowsResponse>> {
	return axiosInstance.get('/analytics/overview/rows', { params, ...config })
}
